import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
class ImageCropper extends PureComponent {

	onMouseMove = ev => {
		if (ev.touches && ev.touches.length) {
			ev = ev.touches[0]
		}
		const mouseXOffset = - (this.mouseX - ev.screenX)
		const mouseYOffset = - (this.mouseY - ev.screenY)
		this.props.positionChanged(this.originalMatrix[4] + mouseXOffset, this.originalMatrix[5] + mouseYOffset)
	}

	onMouseUp = () => {
		window.removeEventListener('mousemove', this.onMouseMove)
		window.removeEventListener('mouseup', this.onMouseUp)
		window.removeEventListener('touchmove', this.onMouseMove)
		window.removeEventListener('touchend', this.onMouseUp)
	}

	onMouseDown = ev => {
		let moveEvent = 'mousemove'
		let upEvent = 'mouseup'
		if (ev.touches && ev.touches.length) {
			ev = ev.touches[0]
			moveEvent = 'touchmove'
			upEvent = 'touchend'
		}
		this.mouseX = ev.screenX
		this.mouseY = ev.screenY
		this.originalMatrix = this.props.matrix
		window.addEventListener(moveEvent, this.onMouseMove)
		window.addEventListener(upEvent, this.onMouseUp)
	}

	createCssMatrix = mat => {
		let i = 0
		let matStr = 'matrix('
		while (i < 6) {
			matStr += mat[i]
			matStr += i === 5 ? '' : ','
			i += 1
		}
		matStr += ')'
		return matStr
	}

	render() {
		return (
			<div
				style={{width: this.props.width + 'px', height: this.props.height + 'px'}}
				onMouseDown={this.onMouseDown} onTouchStart={this.onMouseDown}>
				<img
					ref={elem => {
						this.element = elem
					}}
					src={this.props.image}
					style={{transform: this.createCssMatrix(this.props.matrix), transformOrigin: '50% 50% 0'}}
					onLoad={this.setup} />
				<div
					style={{width: this.props.width + 'px', height: this.props.height + 'px', position: 'absolute', top: 0, left: 0}}>
				</div>
			</div>
		)
	}
}

ImageCropper.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	matrix: PropTypes.arrayOf(PropTypes.number),
	image: PropTypes.shape({
		path: PropTypes.string,
		isFlippedHorizontaly: PropTypes.bool,
		isFlippedVertically: PropTypes.bool,
		scale: PropTypes.number,
	}).isRequired,
	imageProps: PropTypes.shape({
		width: PropTypes.number,
		height: PropTypes.number,
		top: PropTypes.number,
		left: PropTypes.number,
	}),
	positionChanged: PropTypes.func,
}

export default ImageCropper
